import s from "./loading-dots.module.css";

const LoadingDots = () => {
  return (
    <span className={s.root}>
      <span className={s.dot} />
      <span className={s.dot} />
      <span className={s.dot} />
    </span>
  );
};

export default LoadingDots;
